export const DEFAULT_PAYABLE_DATE_OFFSET_DAYS = 30;

// Mirrors influencer_backend_node's utils/payableDate.js: whenever nobody
// has explicitly chosen a payable date yet, it defaults to 30 days out.
// Built on setDate() rather than millisecond arithmetic so month/year
// rollovers (e.g. Jan 31 -> Mar 2) resolve the way Date's own calendar
// math does, instead of assuming every month is exactly 30 days long.
export function getDefaultPayableDate(from = new Date()) {
    const result = new Date(from.getTime());
    result.setDate(result.getDate() + DEFAULT_PAYABLE_DATE_OFFSET_DAYS);
    return result;
}

// Display form for a payable date, e.g. "15-10-2026". Returns '-' for
// missing/invalid input so callers can render it directly without a
// separate fallback branch.
export function formatPayableDate(dateValue) {
    if (!dateValue) return '-';
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '-';
    // Use UTC getters: payableDate is a calendar date, not a point in time,
    // so formatting must not shift with the viewer's timezone.
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
}
